import { ClientActionOptions } from './client-action-options.interface';
import { GenerateUUID } from './uuid';

// Wire contract: X-Client-Action-Id, also captured by the .NET HttpRequestTelemetryInitializer.
// Backend counterpart: CLIENT_ACTION_ID_HEADER in libs/_new-api/_global/logger/src/lib/telemetry/survey-telemetry.constants.ts.
// Node lowercases incoming header names; keep these constants local to their runtimes.
export const CLIENT_ACTION_ID_HEADER = 'X-Client-Action-Id';

// Call once per user action, before retry subscribes to the HTTP observable.
export const createClientActionOptions = (): ClientActionOptions => ({
  headers: { [CLIENT_ACTION_ID_HEADER]: GenerateUUID() }
});
